/* ==========================================================================
   DigiCreative — theme behaviour
   Vanilla JS, no dependencies. Safe to run inside the Shopify theme editor.
   ========================================================================== */
(function () {
  'use strict';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* --------------------------------------------------------------- Header */

  function initHeader(scope) {
    var header = (scope || document).querySelector('[data-dc-header]');
    if (!header || header.dataset.dcHeaderReady === 'true') return;
    header.dataset.dcHeaderReady = 'true';

    if (header.classList.contains('dc-header--overlay')) {
      var onScroll = function () {
        var y = window.scrollY || document.documentElement.scrollTop || 0;
        header.classList.toggle('is-scrolled', y > 40);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var burger = header.querySelector('[data-dc-burger]');
    var nav = header.querySelector('[data-dc-mobile-nav]');
    if (!burger || !nav) return;

    function closeNav() {
      burger.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    }

    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });

    nav.addEventListener('click', function (event) {
      if (event.target.closest('a, button')) closeNav();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        closeNav();
        burger.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!nav.classList.contains('is-open')) return;
      if (!header.contains(event.target)) closeNav();
    });
  }

  /* -------------------------------------------------------- Booking modal */

  /* The weekend dates offered in the dialog. Built here rather than in Liquid
     so a page served from cache cannot offer a Saturday that has already been
     and gone. Starts from tomorrow: nobody books a call for today. */
  function fillBookingDates(select) {
    if (!select || select.dataset.dcFilled === 'true') return;
    select.dataset.dcFilled = 'true';

    var weeks = parseInt(select.getAttribute('data-dc-weeks'), 10) || 8;
    var day = new Date();
    day.setHours(12, 0, 0, 0);
    day.setDate(day.getDate() + 1);

    var last = new Date(day);
    last.setDate(last.getDate() + weeks * 7);

    var format = function (date) {
      return date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
    };

    while (day <= last) {
      if (day.getDay() === 0 || day.getDay() === 6) {
        var option = document.createElement('option');
        option.value = format(day);
        option.textContent = format(day);
        select.appendChild(option);
      }
      day.setDate(day.getDate() + 1);
    }
  }

  function initBookingModal() {
    var modal = document.querySelector('[data-dc-modal]');
    if (!modal || modal.dataset.dcModalReady === 'true') return;
    modal.dataset.dcModalReady = 'true';

    var card = modal.querySelector('.dc-modal__card');
    fillBookingDates(modal.querySelector('[data-dc-booking-dates]'));
    var steps = modal.querySelectorAll('[data-dc-step]');
    var form = modal.querySelector('form');
    var lastFocused = null;

    function showStep(n) {
      each(steps, function (step) {
        step.classList.toggle('is-active', step.getAttribute('data-dc-step') === String(n));
      });
      var focusable = modal.querySelector(
        '.dc-modal__step.is-active input:not([type="hidden"]):not([tabindex="-1"]), .dc-modal__step.is-active textarea, .dc-modal__step.is-active button'
      );
      if (focusable) {
        try { focusable.focus({ preventScroll: true }); } catch (e) { focusable.focus(); }
      }
    }

    function open(step) {
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dc-no-scroll');
      showStep(step || 1);
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dc-no-scroll');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-dc-open-booking]');
      if (!opener) return;
      event.preventDefault();
      open(1);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-dc-close-booking]')) {
        event.preventDefault();
        close();
        return;
      }
      var next = event.target.closest('[data-dc-next-step]');
      if (!next) return;
      event.preventDefault();
      var current = next.closest('[data-dc-step]');
      var invalid = null;
      each(current.querySelectorAll('input, textarea, select'), function (field) {
        if (!invalid && !field.checkValidity()) invalid = field;
      });
      if (invalid) { invalid.reportValidity(); return; }
      showStep(next.getAttribute('data-dc-next-step'));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    // Keep tab focus inside the dialog while it is open.
    modal.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !card) return;
      var items = card.querySelectorAll(
        'a[href], button:not([disabled]), input:not([type="hidden"]):not([tabindex="-1"]), textarea, select'
      );
      var visible = Array.prototype.filter.call(items, function (el) { return el.offsetParent !== null; });
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    /* Submitting reloads the page, so the thank-you cannot simply be shown in
       place — the dialog has to be reopened on the way back. The markers come
       from inside the form, and this dialog is not rendered on the contact
       page, so a contact form result on a page that has it can only be ours. */
    if (modal.querySelector('[data-dc-booking-sent]')) {
      open(3);
    } else if (modal.querySelector('[data-dc-booking-failed]')) {
      open(1);
    }
  }

  /* ------------------------------------------------------- Contact forms */

  /* Nothing here touches how the form submits, deliberately.

     Shopify's spam protection hooks the form's own submit event to attach a
     captcha token, so intercepting the submit and posting with fetch gets the
     enquiry rejected with "Missing CAPTCHA token". And the post has to go to
     /contact: Shopify does not route these by path, so pointing the action at
     the current page 404s. The tag renders the right thing; leave it alone and
     let Shopify redirect back with contact_posted=true, which is what
     form.posted_successfully? reads to render the thank-you. */

  /* The stepped contact form keeps to that. All three steps sit inside the one
     Shopify form; this only shows one at a time and checks the fields of the
     current step before moving on. The last step's button is a plain submit.
     Without this script every step shows at once and the form still works. */

  function initContactSteps(scope) {
    each((scope || document).querySelectorAll('[data-dc-steps]'), function (root) {
      if (root.dataset.dcStepsReady === 'true') return;
      root.dataset.dcStepsReady = 'true';

      var steps = root.querySelectorAll('[data-dc-step]');
      var marks = root.querySelectorAll('[data-dc-step-mark]');
      var total = steps.length;
      var current = 1;
      if (!total) return;

      function stepValid(step) {
        var invalid = null;
        each(step.querySelectorAll('input, textarea, select'), function (field) {
          if (!invalid && !field.checkValidity()) invalid = field;
        });
        if (invalid) { invalid.reportValidity(); return false; }
        return true;
      }

      function show(n, moveFocus) {
        current = n;
        each(steps, function (step) {
          var on = step.getAttribute('data-dc-step') === String(n);
          step.hidden = !on;
          step.classList.toggle('is-entering', on && !!moveFocus);
        });
        each(marks, function (mark) {
          var m = parseInt(mark.getAttribute('data-dc-step-mark'), 10);
          mark.classList.toggle('is-active', m === n);
          mark.classList.toggle('is-done', m < n);
          if (m === n) mark.setAttribute('aria-current', 'step');
          else mark.removeAttribute('aria-current');
        });
        root.style.setProperty('--dc-progress', (n / total * 100) + '%');
        if (!moveFocus) return;

        // Bring the top of the form back into view on long steps.
        var header = document.querySelector('[data-dc-header]');
        var offset = (header ? header.offsetHeight : 0) + 24;
        var top = root.getBoundingClientRect().top;
        if (top < offset) window.scrollTo({ top: window.pageYOffset + top - offset, behavior: 'smooth' });

        var first = steps[n - 1].querySelector('input:not([type="hidden"]):not([disabled]), textarea');
        if (first) {
          try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
        }
      }

      root.addEventListener('click', function (event) {
        var go = event.target.closest('[data-dc-step-go]');
        if (!go) return;
        event.preventDefault();
        var target = parseInt(go.getAttribute('data-dc-step-go'), 10);
        if (target > current && !stepValid(steps[current - 1])) return;
        show(target, true);
      });

      // Enter in a field would otherwise send the whole form from an early step.
      root.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || current >= total) return;
        var el = event.target;
        if (el.tagName !== 'INPUT' || el.type === 'submit' || el.type === 'button') return;
        event.preventDefault();
        if (stepValid(steps[current - 1])) show(current + 1, true);
      });

      // A follow-up field shows for one answer only. Disabled when hidden, so
      // an empty line does not arrive in the email.
      each(root.querySelectorAll('[data-dc-follow-up]'), function (box) {
        var group = box.closest('fieldset');
        var input = box.querySelector('input');
        var trigger = box.getAttribute('data-dc-follow-up');
        function sync() {
          var picked = group.querySelector('input[type="radio"]:checked');
          var on = !!picked && picked.value === trigger;
          box.hidden = !on;
          input.disabled = !on;
        }
        group.addEventListener('change', sync);
        sync();
      });

      // A question held back until an earlier answer is picked. Disabling its
      // fieldset keeps a hidden answer out of the email and out of validation,
      // without touching the disabled state of anything inside it.
      each(root.querySelectorAll('[data-dc-show-if]'), function (gate) {
        var name = 'contact[' + gate.getAttribute('data-dc-show-if') + ']';
        var value = gate.getAttribute('data-dc-show-value');
        var radios = Array.prototype.filter.call(root.querySelectorAll('input[type="radio"]'), function (radio) {
          return radio.name === name;
        });
        function sync() {
          var on = radios.some(function (radio) { return radio.checked && radio.value === value; });
          gate.hidden = !on;
          gate.disabled = !on;
        }
        radios.forEach(function (radio) { radio.addEventListener('change', sync); });
        sync();
      });

      each(root.querySelectorAll('[data-dc-step-go], [data-dc-steps-track]'), function (el) { el.hidden = false; });
      root.classList.add('is-stepped');
      root.dcShowStep = show;
      show(1, false);
    });
  }

  /* After sending, Shopify reloads the page at /contact...#ContactForm, which
     drops the visitor halfway down with the heading under the header. When the
     thank-you is showing, clear the anchor and start from the top instead; the
     message still gets focus (without scrolling) so it is announced. */

  function initContactSent() {
    var done = document.querySelector('[data-dc-form-done]');
    if (!done || done.dataset.dcDoneReady === 'true') return;
    done.dataset.dcDoneReady = 'true';

    if (location.hash && window.history && history.replaceState) {
      history.replaceState(null, '', location.pathname + location.search);
    }

    function toTop() {
      try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, 0); }
    }
    toTop();
    // The browser can still apply the anchor jump once the page finishes loading.
    window.addEventListener('load', function () { toTop(); }, { once: true });

    try { done.focus({ preventScroll: true }); } catch (e) { /* focus is a nicety */ }
  }

  /* -------------------------------------------------------------- Reveal */

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-dc-reveal]:not(.is-revealed)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      each(items, function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-dc-reveal'), 10) || 0;
        el.style.animationDelay = delay + 'ms';
        el.classList.add('is-revealed');
        observer.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    each(items, function (el) { observer.observe(el); });
  }

  /* ----------------------------------------------------------------- FAQ */

  function faqSetOpen(item, open) {
    item.setAttribute('data-open', open ? 'true' : 'false');
    var btn = item.querySelector('.dc-faq__q');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function faqCollapseAll(root) {
    each(root.querySelectorAll('.dc-faq__item'), function (item) { faqSetOpen(item, false); });
  }

  function faqRenumberWithin(container) {
    var n = 0;
    each(container.querySelectorAll('.dc-faq__item'), function (item) {
      if (item.hidden) return;
      n += 1;
      var label = item.querySelector('.dc-faq__n');
      if (label) label.textContent = n < 10 ? '0' + n : String(n);
    });
  }

  // Where items are grouped under headings, numbering restarts in each group.
  function faqRenumber(root) {
    var groups = root.querySelectorAll('[data-dc-group]');
    if (!groups.length) { faqRenumberWithin(root); return; }
    each(groups, function (group) { faqRenumberWithin(group); });
  }

  // A heading with nothing left under it should go too.
  function faqSyncGroups(root) {
    each(root.querySelectorAll('[data-dc-group]'), function (group) {
      var visible = false;
      each(group.querySelectorAll('.dc-faq__item'), function (item) {
        if (!item.hidden) visible = true;
      });
      group.hidden = !visible;
    });
  }

  function faqOpenFirstVisible(root) {
    var items = root.querySelectorAll('.dc-faq__item');
    for (var i = 0; i < items.length; i += 1) {
      if (!items[i].hidden) { faqSetOpen(items[i], true); return; }
    }
  }

  function initFaq(scope) {
    each((scope || document).querySelectorAll('[data-dc-faq]'), function (root) {
      if (root.dataset.dcFaqReady === 'true') return;
      root.dataset.dcFaqReady = 'true';

      each(root.querySelectorAll('.dc-chip--filter'), function (chip) {
        chip.addEventListener('click', function () {
          var topic = chip.getAttribute('data-topic') || '';

          each(root.querySelectorAll('.dc-chip--filter'), function (other) {
            other.setAttribute('aria-pressed', String(other === chip));
          });
          each(root.querySelectorAll('.dc-faq__item'), function (item) {
            item.hidden = topic !== '' && item.getAttribute('data-topic') !== topic;
          });

          faqSyncGroups(root);
          faqCollapseAll(root);
          faqRenumber(root);
          // Only auto-open after filtering if the section opens the first item at all.
          if (root.getAttribute('data-dc-open-first') === 'true') faqOpenFirstVisible(root);
        });
      });

      root.addEventListener('click', function (event) {
        var btn = event.target.closest('.dc-faq__q');
        if (!btn) return;
        var item = btn.closest('.dc-faq__item');
        var wasOpen = item.getAttribute('data-open') === 'true';
        faqCollapseAll(root);
        if (!wasOpen) faqSetOpen(item, true);
      });
    });
  }

  /* -------------------------------------------------------------- Copy */

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return Promise.reject(new Error('clipboard unavailable'));
  }

  // execCommand still works where the async clipboard API is blocked —
  // notably inside the theme editor's iframe.
  function copyTextFallback(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.top = '-1000px';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    field.setSelectionRange(0, field.value.length);
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(field);
    return ok;
  }

  // If both copy routes fail, select the text so the Ctrl+C hint is actionable.
  function selectElementText(el) {
    try {
      var range = document.createRange();
      range.selectNodeContents(el);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    } catch (e) { /* selection unsupported */ }
  }

  function initCopy(scope) {
    each((scope || document).querySelectorAll('[data-dc-copy]'), function (btn) {
      if (btn.dataset.dcCopyReady === 'true') return;
      btn.dataset.dcCopyReady = 'true';

      var label = btn.querySelector('[data-dc-copy-label]') || btn;
      var idle = label.textContent;
      var done = btn.getAttribute('data-dc-copied-label') || 'Copied';
      var failed = btn.getAttribute('data-dc-failed-label') || 'Press Ctrl+C';
      var timer = null;

      function flash(cls, text) {
        btn.classList.remove('is-copied', 'is-failed');
        btn.classList.add(cls);
        label.textContent = text;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove('is-copied', 'is-failed');
          label.textContent = idle;
        }, 2400);
      }

      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-dc-copy'));
        if (!target) return;
        var text = target.textContent;

        copyText(text).then(
          function () { flash('is-copied', done); },
          function () {
            if (copyTextFallback(text)) {
              flash('is-copied', done);
            } else {
              selectElementText(target);
              flash('is-failed', failed);
            }
          }
        );
      });
    });
  }

  /* --------------------------------------------------- Reading progress */

  function initReadingProgress(scope) {
    var wrapper = (scope || document).querySelector('[data-dc-progress]');
    if (!wrapper || wrapper.dataset.dcProgressReady === 'true') return;

    var bar = wrapper.querySelector('.post-progress__bar');
    var target = document.querySelector('[data-dc-progress-target]');
    if (!bar || !target) return;
    wrapper.dataset.dcProgressReady = 'true';

    var ticking = false;

    function update() {
      ticking = false;
      var rect = target.getBoundingClientRect();
      var startY = rect.top + window.scrollY;
      var travel = rect.height - window.innerHeight;
      var progress;

      if (travel <= 0) {
        // Article shorter than the viewport: nothing to track.
        progress = window.scrollY > startY ? 1 : 0;
      } else {
        progress = (window.scrollY - startY) / travel;
      }

      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      bar.style.transform = 'scaleX(' + progress + ')';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      // Without the fallback, a missing rAF would leave ticking stuck on and
      // freeze the bar for the rest of the page's life.
      if (window.requestAnimationFrame) window.requestAnimationFrame(update);
      else update();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------- Boot */

  function init(scope) {
    initHeader(scope);
    initReveal(scope);
    initFaq(scope);
    initCopy(scope);
    initReadingProgress(scope);
    initBookingModal();
    initContactSteps(scope);
    initContactSent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // The theme editor swaps section markup without reloading the page.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  // Selecting a contact form question in the editor should show its step.
  document.addEventListener('shopify:block:select', function (event) {
    var step = event.target.closest ? event.target.closest('[data-dc-step]') : null;
    var root = step ? step.closest('[data-dc-steps]') : null;
    if (root && root.dcShowStep) root.dcShowStep(parseInt(step.getAttribute('data-dc-step'), 10), false);
  });

  // Selecting an FAQ block in the editor should reveal and open that question.
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest ? event.target.closest('.dc-faq__item') : null;
    if (!item) return;
    var root = item.closest('[data-dc-faq]');
    if (!root) return;
    item.hidden = false;
    var group = item.closest('[data-dc-group]');
    if (group) group.hidden = false;
    faqCollapseAll(root);
    faqSetOpen(item, true);
  });
})();
